import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CollectionState {
    productId: string;
    productImageUrl: string;
}
export interface CollectionSlice {
    productId: string;
    productImageUrl: string;
    lastRemovedProductId: string;
    collectionOne: CollectionState;
    collectionTwo: CollectionState;
    collectionCount: number;
}

// Split into pending and active filters.
const initialState: CollectionSlice = {
    productId: "",
    productImageUrl: "",
    lastRemovedProductId: "",
    collectionOne: {
        productId: "",
        productImageUrl: "",
    },
    collectionTwo: {
        productId: "",
        productImageUrl: "",
    },
    collectionCount: 1,
};
const collection = createSlice({
    name: "Collections",
    initialState,
    reducers: {
        addCollection(state, action: PayloadAction<CollectionState>): void {
            if (state.collectionOne.productId === "") {
                state.collectionOne = action.payload;
                state.lastRemovedProductId = initialState.lastRemovedProductId;
                state.collectionCount += 1;
            } else if (state.collectionTwo.productId === "") {
                state.collectionTwo = action.payload;
                state.lastRemovedProductId = initialState.lastRemovedProductId;
                state.collectionCount += 1;
            }
        },
        clearCollection(state, action: PayloadAction<string>): void {
            if (state.collectionOne.productId === action.payload) {
                state.collectionOne = initialState.collectionOne;
            } else if (state.collectionTwo.productId === action.payload) {
                state.collectionTwo = initialState.collectionOne;
            }
            state.lastRemovedProductId = action.payload;
            state.collectionCount -= 1;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = collection;
// Extract and export each action creator by name
export const { addCollection, clearCollection } = actions;
// Export the reducer, either as a default or named export
export default reducer;
